module.exports = __webpack_public_path__ + "media/images/area/feature/banner/sp/ko_tohoku-7903caa06596f0602faf810f85c7faa9.jpg";